import React from 'react'
import { observer } from 'mobx-react'
import UIRating from '@ui/QuestionsType/Rating'

function Rating({ mapped, onPartial, inactive }) {
  return (
    <UIRating
      buttons={mapped.choices}
      onSelect={onPartial}
      selected={mapped.answer}
      inactive={inactive}
      splitted={mapped.splitted}
      dontKnowButton={mapped.dontKnowButton}
      legends={mapped.legends}
    />
  )
}

export default observer(Rating)
